module.exports = __webpack_public_path__ + "6e10627c38977fc1e5f52aef932a6f5a.svg";